import React from "react";

import type { TypeMenuItemProps } from "../MenuItem";
import type { TypeAutocompleteProps } from "./AutocompleteTypes";
import { SingleAutocomplete } from "./SingleAutocomplete";
import { MultiAutocomplete } from "./MultiAutocomplete";

/**
 * @link https://seeds.sproutsocial.com/components/autocomplete/
 *
 * @description A Autocomplete allows selecting {@link https://seeds.sproutsocial.com/components/seeds-react-menu/#menuitem MenuItems} from a list or groups of lists to populate an input.
 *
 */
export const Autocomplete = <I extends TypeMenuItemProps = TypeMenuItemProps>({
  multiSelect = false,
  ...rest
}: TypeAutocompleteProps<I>) => {
  if (multiSelect) {
    return <MultiAutocomplete {...rest} />;
  }

  return <SingleAutocomplete {...rest} />;
};
